import supabase from '../supabase';
// API Service для работы с Cloudflare Workers
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://your-worker-url.workers.dev';

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    };

    const config = {
      ...defaultOptions,
      ...options,
      headers: {
        ...defaultOptions.headers,
        ...options.headers,
      },
    };

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Получить список кейсов
  async getCases() {
    return this.request('/api/cases');
  }

  // Получить баланс пользователя
  async getUserBalance(userId) {
    return this.request(`/api/user/balance/${userId}`);
  }

  // Создать платеж
  async createPayment(userId, amount, currency, paymentMethod = 'telegram') {
    return this.request('/api/payment/create', {
      method: 'POST',
      body: JSON.stringify({
        userId,
        amount,
        currency,
        paymentMethod,
      }),
    });
  }

  // Подтвердить платеж
  async confirmPayment(transactionId, paymentData) {
    return this.request('/api/payment/confirm', {
      method: 'POST',
      body: JSON.stringify({
        transactionId,
        paymentData,
      }),
    });
  }

  // Получить историю платежей пользователя
  async getUserPayments(userId, limit = 10, offset = 0) {
    return this.request(`/api/user/payments/${userId}?limit=${limit}&offset=${offset}`);
  }

  // Ручное пополнение (для администраторов)
  async manualTopUp(userId, amount, currency, reason) {
    return this.request('/api/admin/topup', {
      method: 'POST',
      body: JSON.stringify({
        userId,
        amount,
        currency,
        reason,
      }),
    });
  }

  // --- SUPABASE METHODS ---

  // Создать пользователя
  async createUser({ id, name, username, avatar }) {
    const { data, error } = await supabase.from('users').insert([{ id, name, username, avatar }]);
    if (error) throw error;
    return data[0];
  }

  // Получить пользователя по id
  async getUser(userId) {
    const { data, error } = await supabase.from('users').select('*').eq('id', userId).single();
    if (error) throw error;
    return data;
  }

  // Получить баланс пользователя
  async getUserBalanceSupabase(userId) {
    const { data, error } = await supabase.from('users').select('balance').eq('id', userId).single();
    if (error) throw error;
    return data ? data.balance : 0;
  }

  // Пополнить баланс пользователя
  async topUpBalance(userId, amount) {
    const { data, error } = await supabase.rpc('top_up_balance', { user_id: userId, amount });
    if (error) throw error;
    return data;
  }

  // Получить историю платежей пользователя
  async getPaymentsSupabase(userId, limit = 10, offset = 0) {
    const { data, error } = await supabase
      .from('payments')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
      .range(offset, offset + limit - 1);
    if (error) throw error;
    return data;
  }

  // Добавить запись о платеже
  async addPaymentSupabase({ user_id, amount, currency, method, status }) {
    const { data, error } = await supabase.from('payments').insert([
      { user_id, amount, currency, method, status }
    ]);
    if (error) throw error;
    return data[0];
  }
}

export default new ApiService(); 